import React from 'react';
import { FiLock, FiFileText } from 'react-icons/fi';

const TableView = ({ data, type, onDetail }) => {
  return (
    <div className="table-view-container">
      <table className="board-table">
        <thead>
          <tr>
            <th className="th-num">번호</th>
            <th className="th-title">제목</th>
            <th className="th-writer">작성자</th>
            <th className="th-date">날짜</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item) => (
              /* Detail로 갈 때는 기존 item 객체 그대로 넘기므로 item.id를 사용함 */
              <tr key={item.id} className={item.isNotice ? 'pinned-notice' : ''} onClick={() => onDetail(item)}>
                {/* [수정] 눈속임용 번호(displayNo) 출력. id는 내부적으로만 작동함 */}
                <td className="td-num">{item.isNotice ? <span className="pinned-icon">📌</span> : item.displayNo}</td>

                <td className="td-title">
                  <div className="title-wrapper">
                    {(item.isPrivate || Number(item.is_private) === 1) && <FiLock className="lock-icon" />}
                    <span className="title-txt">{item.title}</span>
                    {(item.file_url || item.hasFile) && <FiFileText className="file-icon" />}
                  </div>
                </td>

                <td className="td-writer">{item.writer || item.author_name}</td>
                <td className="td-date">{item.date}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="no-data">
                등록된 게시물이 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableView;
